import React from "react";

export default class ProfileImage extends React.Component {
  render() {
    return (
      <img
        src={"https://i.postimg.cc/Y9WG3rb1/IMG-20230204-193510.jpg"}
        alt="Avatar"
        className="profileImage"
      />
    );
  }
}
